function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { Anchor, StyledLargeLogo, StyledSmallLogo } from "./styles";
export const Logo = ({
  ...props
}) => {
  const {
    handleRoutePush,
    homeAsPath
  } = useSdkContext();
  return /*#__PURE__*/React.createElement(Anchor, _extends({}, props, {
    href: homeAsPath,
    onClick: event => {
      event.preventDefault();
      void handleRoutePush(homeAsPath);
    },
    "data-qa": "logo"
  }), /*#__PURE__*/React.createElement(StyledLargeLogo, null), /*#__PURE__*/React.createElement(StyledSmallLogo, null));
};
Logo.displayName = "Logo";